import Vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios'
import {getAnnotationMsgcount} from "@/common/functions";

let jwtDecode = require('jwt-decode')

Vue.use(Vuex)

let key = 'AuthToken'
const store = new Vuex.Store({
  state: {
    count: 0,
    userId: 0,
    tenantId: 0,
    roleId: 0,
    userName: '',
    roleName: '',
    stateLoaded: false,
    userLoaded: false,
    screenConfig: [],
    reportScreenConfig: [],
    exploratoryScreenConfig: [],
    superAdmin: false,
    showBanner: true,
    showSideMenu: true,
    tenantAdmin: false,
    serverIsDown: false,
    dataIssue: false,
    authRequired: false,
    annotations: [],
    user: null,
    roleSwitchConfirmation: false,
    authToken: localStorage.getItem(key),
    isLoggedIn: localStorage.getItem(key) != null,
    parentMenuPath: '',
    childMenuPath: '',
    parentMenuId: '',
    childParentId: '',
    lbWhereCond: {},
    apiCount: 0,
    filterType:null,
    isAppMenuAndAppHeaderDisplay:null,
    deviceType: 'null', // 'Mobile' or 'Desktop'
    bannerStatus:false,
    fixedScreen:true,
    filterFlag:false,
    resetSortFlag: false,
    annotationCount:0,
    redirectUrl: null,
    stateLoading: false,
      isBackendError:false,
  },
  mutations: {
      backendError(state,value){
          state.isBackendError = value
      },
    setRedirectUrl(state,value){
      state.redirectUrl = value
    },
    setAnnotationCount(state,value){
      state.annotationCount = value
    },
    setResetSortFlag(state, value) {
      state.resetSortFlag = value
    },
    setFilterFlag(state, value){
      state.filterFlag = value
    },
    setFixedScreenFlag(state){
      state.fixedScreen = !state.fixedScreen
      // console.log(state.fixedScreen)
    },
    setDeviceType(state, deviceType) {
      state.deviceType = deviceType;
    },
    isAppMenuAndAppHeaderDisplay(state,at){
      state.isAppMenuAndAppHeaderDisplay = at
    },
    serverDown (state) {
      state.serverIsDown = true
    },
    serverError (state) {
      state.dataIssue = true
    },
    authError (state) {
      state.authRequired = true
    },
    roleSwitchConfirmation (state) {
      state.roleSwitchConfirmation = true
    },
    setLBwhereCond (state, kv) {
      state.lbWhereCond[kv.k] = kv.v
      // console.log("LB store value",kv.k, kv.v,state.lbWhereCond)
    },
    clearError (state) {
      state.serverIsDown = false
      state.dataIssue = false
      state.authRequired = false
    },
    toggleBanner (state) {
      state.showBanner = !state.showBanner
      state.bannerStatus = state.showBanner
    },
    toggleSideMenu (state) {
      state.showSideMenu = !state.showSideMenu
    },
    increment (state, by) {
      state.count += by
    },
    setState (state, cfg) {
      state.reportScreenConfig = cfg.reportScreenConfig
      state.fwScreenConfig = cfg.fwScreenConfig
      state.fwConfigScreenElement = cfg.fwConfigScreenElement
      state.fwConfigMenuScreenRender = cfg.fwConfigMenuScreenRender
      state.fwSVizConfigScreen = cfg.fwSVizConfigScreen
      state.colummnMetaData = cfg.colummnMetaData
      state.menuMasterData = cfg.menuMasterData
      state.menuTree = cfg.menuTree
      state.menuMasterFlat = cfg.menuMasterFlat
      state.fwMClient=cfg.fwMClient
      state.vizType = cfg.vizType
      state.actionIcons = cfg.actionIcons
      state.listbox = cfg.listbox
      state.reportMaster = cfg.reportMaster
      state.roleSwitch = cfg.roleSwitch
      state.stateLoaded = true
    },
    saveAnnotations (state, ann) {
      state.annotations = ann
    },
    saveUser (state, user) {

      state.userId = user.userId        //why this ????
      state.clientId = user.clientId
      state.userRoles = user.userRoles
      state.userRoleRestriction = user.userRoleRestriction
      state.userName = user.userName
      state.firstName = user.firstName
      state.roleName = user.userRoleRestriction.roleName
      state.user = user
      state.userLoaded = true
      state.filterType = user.filterType
      // localStorage.setItem('USER', JSON.stringify(user))
    },
    loggedOut (state) {
      state.isLoggedIn = false
      state.accessToken = null
      state.userId = null
      state.clientId = null
      state.userRoles = []
      state.isRoleSelected = false
      state.roleSwitchConfirmation = false

      //reset preferences of user...
      state.showBanner = true
      state.showSideMenu = true
      state.serverIsDown = false
      state.dataIssue = false
      state.authRequired = false
      localStorage.removeItem(key)
      axios.defaults.headers.common['Authorization'] = null
    },
    loggedIn (state, at) {
      state.authToken = at
      state.isLoggedIn = true
      state.isRoleSelected = true
      //set state to false, so we'll reload all stated for the logged in user
      state.stateLoaded = false

      let decoded = jwtDecode(at)
      state.userId = decoded['userId']
      state.clientId = decoded['clientId']
      //state.userRoles = decoded['userRoles'] //commented due to global where clause userRoles value is getting reset while calling context.commit(loggedIn)

      axios.defaults.headers.common['Authorization'] = `${at}`
      localStorage.setItem(key, at)

    },
    menuPath (state, path) {
      state.parentMenuPath = path['p']
      state.childMenuPath = path['c']
      state.parentMenuId = path['pId']
      state.childParentId = path['cId']
    },
    httpCall(state, inc) {
      state.apiCount += inc
    }
  },
  actions: {
    loadMenuPath (context, path) {
      context.commit('menuPath', path)
    },
    loadAnnotations (context) {
      return new Promise(((resolve, reject) => {
        axios.get('/api/annotation')
          .then(res => {
            context.commit('saveAnnotations', res.data)
            resolve('done')
          }, err => {
            console.error('error is loading annotations', err)
            reject(Error('unable to get annotations from server'))
            reject(err)
          })
      }))
    },
      loadState(context) {
          // If state is already loaded, return cached data
          if (context.state.stateLoaded) {
              return Promise.resolve({
                  screenConfig: context.state.screenConfig,
                  fwScreenConfig: context.state.fwScreenConfig,
                  fwConfigScreenElement: context.state.fwConfigScreenElement,
                  fwConfigMenuScreenRender: context.state.fwConfigMenuScreenRender,
                  fwSVizConfigScreen: context.state.fwSVizConfigScreen,
                  reportScreenConfig: context.state.reportScreenConfig,
                  colummnMetaData: context.state.colummnMetaData,
                  menuMasterData: context.state.menuMasterData,
                  menuTree: context.state.menuTree,
                  menuMasterFlat: context.state.menuMasterFlat,
                  fwMClient: context.state.fwMClient,
                  vizType: context.state.vizType,
                  actionIcons: context.state.actionIcons,
                  listbox: context.state.listbox,
                  reportMaster: context.state.reportMaster,
                  roleSwitch: context.state.roleSwitch
              });
          }

          // If another dispatch is already fetching, create a promise that waits
          if (context.state.stateLoading) {
              return new Promise((resolve) => {
                  // Polling approach: check every 100ms until stateLoaded becomes true
                  const checkInterval = setInterval(() => {
                      if (context.state.stateLoaded) {
                          clearInterval(checkInterval);
                          resolve({
                              screenConfig: context.state.screenConfig,
                              fwScreenConfig: context.state.fwScreenConfig,
                              fwConfigScreenElement: context.state.fwConfigScreenElement,
                              fwConfigMenuScreenRender: context.state.fwConfigMenuScreenRender,
                              fwSVizConfigScreen: context.state.fwSVizConfigScreen,
                              reportScreenConfig: context.state.reportScreenConfig,
                              colummnMetaData: context.state.colummnMetaData,
                              menuMasterData: context.state.menuMasterData,
                              menuTree: context.state.menuTree,
                              menuMasterFlat: context.state.menuMasterFlat,
                              fwMClient: context.state.fwMClient,
                              vizType: context.state.vizType,
                              actionIcons: context.state.actionIcons,
                              listbox: context.state.listbox,
                              reportMaster: context.state.reportMaster,
                              roleSwitch: context.state.roleSwitch
                          });
                      }
                  }, 100);
              });
          }

          // Mark as loading
          context.state.stateLoading = true

          return axios.get('/api/state')
              .then(res => {
                  context.commit('setState', res.data)
                  context.state.stateLoaded = true
                  context.state.stateLoading = false
                  return res.data;
              })
              .catch(err => {
                  context.commit('setLoading', false);
                  console.error('Error in fetching state', err);
                  throw new Error('Unable to get state from server');
              });
      },
    checkUserLogin (context) {
      let at = localStorage.getItem(key)
      return new Promise((resolve, reject) => {
        if (at) {
          if (context.state.userLoaded) {
            resolve(context.state.user)
          } else {

            let decoded = jwtDecode(at)
            // console.log("decoded",decoded)
            //console.log("Decoded At",decoded['exp']*1000,Date.now(),decoded['tokenTime'])
            if (decoded['exp'] * 1000 >= Date.now()) {
              let userId = decoded['userId']
              axios.get(`/api/user/${userId}`, {
                headers: {
                  Authorization: at
                }
              }).then(res => {
                let user = res.data
                // console.log(window.location.hash.substring(1),"user resp",res)
                context.commit('setRedirectUrl', window.location.hash.substring(1))
                context.commit('saveUser', user)
                context.commit('loggedIn', at)
                  getAnnotationMsgcount();
                const userAgent = navigator.userAgent.toLowerCase();
                // console.log("userAgent",userAgent);
                let deviceType = 'Desktop'; // Default

                // Check for mobile devices
                if (/mobile|android|iphone|ipad|ipod/.test(userAgent)) {
                  deviceType = 'Mobile';
                }

                context.commit('setDeviceType',deviceType)
                if(window.location.hash.substring(1)==='/field/landing' || window.location.hash.substring(1)==='/field/deepdive' || window.location.hash.substring(1)==='/field/simple'){
                  context.commit('isAppMenuAndAppHeaderDisplay',false);
                }else{
                  context.commit('isAppMenuAndAppHeaderDisplay',true);
                }
                resolve(user)
              }, err => {
                console.error('error in checking user, lets logout', err)
                context.commit('loggedOut')
                reject(Error('authToken invalid'))
              })
            } else {
              console.error('AuthToken Expired, lets logout')
              // alert("AuthToken Expired, lets logout")
              context.commit('loggedOut')
              reject(Error('authToken Expired'))
            }
          }
        } else {
          context.commit('authError')
          reject(Error('authToken missing'))
        }
      })
    },
    ajaxStart(context){
      context.commit('httpCall', 1)
    },
    ajaxComplete(context){
      context.commit('httpCall', -1)
    }
  }
})
export default store